module.exports = __webpack_public_path__ + "static/media/unread.28d60b31.svg";